import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";
import { getAllAccounts } from "../api/global_collections/accounts";

export const globalAccountsKeys = {
  all: ["globalAccounts"] as const,
};

export const useGlobalAccounts = () => {
  const auth0 = useAuth0();
  return useQuery({
    queryKey: globalAccountsKeys.all,
    queryFn: () => getAllAccounts(auth0),
    enabled: !!auth0,
    refetchOnWindowFocus: true,
    refetchOnReconnect: false,
    refetchInterval: false,
  });
}; 